import type { UserId } from '@/schemas/ids';
import { downloadRemoteImages } from './download';
import { mergeRemoteImages } from './merge';
import { uploadPendingImages } from './upload';

export interface SyncResult {
  uploadedCount: number;
  downloadedCount: number;
}

export class ImagesSyncError extends Error {
  constructor(
    message: string,
    public readonly userId: UserId,
    public readonly type: 'upload' | 'download' | 'full',
    public readonly originalError: unknown,
  ) {
    super(message);
    this.name = 'ImagesSyncError';
  }
}

/**
 * Sync images: upload pending images, download remote images, merge conflicts
 */
export async function syncImages(userId: UserId): Promise<SyncResult> {
  try {
    const up = await uploadPendingImages(userId);
    const down = await downloadRemoteImages(userId);
    await mergeRemoteImages(down.images);
    return { uploadedCount: up.uploaded, downloadedCount: down.images.length };
  } catch (error) {
    throw new ImagesSyncError(
      error instanceof Error ? error.message : 'Images sync failed',
      userId,
      'full',
      error,
    );
  }
}
